import { Button, List, ListItem, Stack, Typography } from '@mui/material';
import upsellImage from '../../../../images/data-dashboard-1.png';
import { useSubmitSalesAttributionRequestMutation } from '@components/Dashboard/dashboardSlice/campaignsApi';
import { enqueueSnackbar } from 'notistack';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import { useState } from 'react';

type UpsellProps = {
  campaignId: number;
  requested: boolean;
};

export const Upsell = (props: UpsellProps) => {
  const [submitSalesRequest] = useSubmitSalesAttributionRequestMutation();
  const [requested, setRequested] = useState(props.requested);

  const handleRequest = () => {
    try {
      // TODO: remove void here?
      void submitSalesRequest(props.campaignId).unwrap();
      setRequested(true);
      enqueueSnackbar('Sales Attribution Requested', { variant: 'success' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error requesting Sales Attribution', {
        variant: 'error',
      });
    }
  };

  return (
    <Stack
      direction="row"
      gap="1.5rem"
      paddingY="1.5rem"
      paddingX="1rem"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      sx={{
        backgroundColor: unifiedPlatformColorPalette.lightGreen50,
        borderRadius: '0.5rem',
      }}
    >
      <Stack direction="column" gap="1.5rem">
        <Stack direction="column" gap="1rem">
          <Typography variant="h4" fontWeight="bold">
            Discover your Sales Attribution
          </Typography>
          <Typography>
            Sales Attribution is a weekly report that may be added to a campaign
            at any time upon request.
          </Typography>

          <Stack direction="column">
            <Typography>Sales Attribution provides:</Typography>
            <List
              sx={{
                listStyleType: 'disc',
                listStylePosition: 'inside',
                padding: 0,
              }}
            >
              <ListItem sx={{ display: 'list-item', paddingY: 0 }}>
                Incremental Sales Lift
              </ListItem>
              <ListItem sx={{ display: 'list-item', paddingY: 0 }}>
                ROAS (Return on Ad Spend)
              </ListItem>
              <ListItem sx={{ display: 'list-item', paddingY: 0 }}>
                Separate In-Store and Online Sales Measurements (if applicable)
              </ListItem>
            </List>
          </Stack>
        </Stack>

        <Button
          variant="outlined"
          color="primary"
          onClick={handleRequest}
          disabled={requested}
          sx={{ width: 'fit-content' }}
        >
          {requested
            ? 'Request submitted to your Account Manager'
            : 'Get Access To Sales Attribution'}
        </Button>
      </Stack>

      <img src={upsellImage} alt="Upsell" height={160} width={257} />
    </Stack>
  );
};
